import { render, staticRenderFns } from "./VerandaPanelMaterials.vue?vue&type=template&id=615ef4a7&scoped=true"
import script from "./VerandaPanelMaterials.vue?vue&type=script&lang=ts"
export * from "./VerandaPanelMaterials.vue?vue&type=script&lang=ts"
import style0 from "./VerandaPanelMaterials.vue?vue&type=style&index=0&id=615ef4a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ef4a7",
  null
  
)

export default component.exports